module.exports = __webpack_public_path__ + "static/media/lingua-screenshot-1.21185590.png";